const AboutUsMiddleVector = ({ width = 508, height = 904, fill = "#F8EDE3", className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 508 904"
      fill="none"
      className={className}
    >
      <path
        d="M589.062 1.57542L5.73688 302.015C0.904847 304.504 -0.98035 310.436 1.5 315.252L301.94 898.578C304.471 903.491 310.616 905.431 315.48 902.844C637.837 730.804 765.093 333.24 602.555 5.98932C600.098 1.0587 593.968 -0.930543 589.071 1.5917L589.062 1.57542Z"
        fill={fill}
      />
    </svg>
  );
};

export default AboutUsMiddleVector;
